import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  ScreenDisplayHeaderActions,
  TabButtonFlatButton,
  TextInputField,
} from "../../../common-components";
import { OffenseHeader, OffenseItem } from "./components";
import AddOffensePopUp from "./components/add-offense-popup/AddOffensePopUp";
import SearchBar from "../../../common-components/search-bar/SearchBar";

const OffensesDisplay = ({
  width,
  height,
  setToastPop,
  setMessage,
  setLoading,
  loading,
  setPopUpTitle,
  auth,
  refresh,
  setRefresh,
}) => {
  const [open, setOpen] = useState(false);
  const [offenseArray, setOffenseArray] = useState([]);

  const [activeView, setActiveView] = useState("search");

  const [selectedOffense, setSelectedOffense] = useState(null);
  console.log("selectedOffense", selectedOffense);

  const [originalDataArray, setOriginalDataArray] = useState([]); //retain original data for clearing search

  const getOffenseArray = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/offense/getOffenseData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          } /*,
          body: JSON.stringify({
            userId: auth.customerUserData.userId,
          }),*/,
        }
      );

      const responseData = await response.json();
      if (responseData.success) {
        setOffenseArray(responseData.offenseData);
        setOriginalDataArray(responseData.offenseData);
        setLoading(false);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(responseData.message);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "No network try again after connecting, if this persist please contact support"
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    setOpen(true);
  }, []);
  useEffect(() => {
    getOffenseArray();
  }, [refresh]);
  useEffect(() => {
    getOffenseArray();
  }, []);
  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        transition: "all 0.8s",
        position: "absolute",
        top: 0,
        backgroundColor: open ? colors.secondaryGrey : colors.primaryBlue,
        flexDirection: "column",
      }}
    >
      {activeView === "add" ? null : (
        <div
          style={{
            height: 55,
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ marginLeft: 20, fontSize: 18, fontWeight: "bold" }}>
            OFFENSES
          </div>
          <div style={{ flex: 0.5 }}></div>

          <SearchBar
            originalSearchArray={originalDataArray}
            arrayToSearchInput={offenseArray}
            setResultsArray={setOffenseArray}
          />
          <div style={{ flex: 0.5 }}></div>
          <div style={{ marginRight: 10 }}>
            <BaseButtons
              label={"+ ADD OFFENSE"}
              width={150}
              onClick={() => setActiveView("add")}
              // display="flex"
              // justifyContent="flex-end"
              marginRight={50}
              backgroundColor={colors.greenLight}
              borderRadius={10}
            />
          </div>
        </div>
      )}
      {activeView === "add" ? null : <OffenseHeader />}
      <div
        style={{
          flex: 1,
          width: "100%",
          //   flexWrap: "wrap",
          display: "flex",
          overflow: "scroll",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "column",
          //   borderStyle: "solid",
        }}
      >
        {offenseArray
          ? offenseArray.map((offense, index) => {
              return (
                <div key={index} style={{ width: "100%" }}>
                  <OffenseItem
                    onViewClick={() => {
                      setSelectedOffense(offense);
                      setActiveView("manage");
                    }}
                    OffenseReference={offense.offenseReference}
                    Vehicle={offense.vehicleIdentifier}
                    IncidentDate={offense.incidentDate.substring(0, 10)}
                    Description={offense.offenseDescription}
                    User={offense.loggedByUserName}
                  />
                </div>
              );
            })
          : null}
      </div>
      {activeView === "add" ? (
        <AddOffensePopUp
          activeView={activeView}
          setActiveView={setActiveView}
          loading={loading}
          setLoading={setLoading}
          auth={auth}
          setRefresh={setRefresh}
          refresh={refresh}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
          setMessage={setMessage}
        />
      ) : null}
      {activeView === "manage" ? (
        <div
          style={{
            flex: 1,
            backgroundColor: colors.white,
            position: "absolute",
            top: 0,
            display: "flex",
            width: "100%",
            height: "100%",
            position: "absolute",
            flexDirection: "column",
          }}
        >
          <div style={{ position: "absolute", top: 20, left: 20, zIndex: 10 }}>
            <BaseButtons
              label={"BACK"}
              backgroundColor={colors.orangeDark}
              borderRadius={4}
              width={100}
              onClick={() => {
                setActiveView("");
                setSelectedOffense(null);
              }}
            />
          </div>

          <div
            style={{
              position: "absolute",
              left: 140,
              top: 30,
              fontSize: 16,
              fontWeight: "bold",
            }}
          >
            Reference:{" "}
            {selectedOffense ? selectedOffense.offenseReference : "loading"}
          </div>
          <div
            style={{
              width: "100%",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <div style={{ marginTop: 80 }}>
              <div
                style={{
                  marginBottom: 4,
                  marginLeft: 20,
                  fontSize: 12,
                  fontWeight: "bold",
                  opacity: 0.7,
                }}
              >
                Incident date:
              </div>
              <div style={{ marginBottom: 10, marginLeft: 20 }}>
                {selectedOffense ? selectedOffense.incidentDate : "loading"}
              </div>
              <div
                style={{
                  marginBottom: 4,
                  marginLeft: 20,
                  fontSize: 12,
                  fontWeight: "bold",
                  opacity: 0.7,
                }}
              >
                Created date:
              </div>
              <div style={{ marginBottom: 10, marginLeft: 20 }}>
                {selectedOffense ? selectedOffense.createdDate : "loading"}
              </div>
              <div
                style={{
                  marginBottom: 4,
                  marginLeft: 20,
                  fontSize: 12,
                  fontWeight: "bold",
                  opacity: 0.7,
                }}
              >
                Vehicle Identifier:
              </div>
              <div style={{ marginBottom: 10, marginLeft: 20 }}>
                {selectedOffense
                  ? selectedOffense.vehicleIdentifier
                  : "loading"}
              </div>
              <div
                style={{
                  marginBottom: 4,
                  marginLeft: 20,
                  fontSize: 12,
                  fontWeight: "bold",
                  opacity: 0.7,
                }}
              >
                Fine description:
              </div>
              <div style={{ marginBottom: 10, marginLeft: 20 }}>
                {selectedOffense
                  ? selectedOffense.offenseDescription
                  : "loading"}
              </div>
              {/* // document display and expand */}
              <div
                style={{
                  height: "90%",
                  borderStyle: "solid",
                  position: "absolute",
                  right: 20,
                  width: 500,
                  top: 20,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                This is document space
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default OffensesDisplay;
